import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const Error404: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full w-full flex flex-col items-center justify-center bg-gray-50">
      <h1 className="text-7xl font-bold text-slate-700 mb-4">404</h1>

      <h2 className="text-2xl font-semibold text-slate-700 mb-2">{t('error-404-title')}</h2>

      <p className="text-slate-500 mb-8 text-center max-w-sm">{t('error-404-description')}</p>

      <a
        href="/"
        className="px-6 py-3 rounded-xl bg-app-primary text-white hover:bg-app-primary-dark transition shadow-md"
      >
        {t('common-back-to-home')}
      </a>

      <p className="mt-12 text-xs text-slate-400">© {new Date().getFullYear()} AlivioHome. All rights reserved.</p>
    </div>
  );
};

export { Error404 };
